// src/components/ExpertiseSection.jsx
import React from 'react';
import expertise1 from '../assets/images/colour-lending.jpg';
import expertise2 from '../assets/images/Steam-front.jpg';
import expertise3 from '../assets/images/Solvent-front.jpg'
import expertise4 from '../assets/images/cristalization-1.jpg'
// Import other expertise images as needed
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';


const ExpertiseSection = () => {

    const CustomArrow = ({ onClick, direction }) => (
        <button
          onClick={onClick}
          className={`slick-${direction} slick-arrow`}
          aria-label={direction === 'prev' ? 'Previous' : 'Next'}
        >
          {direction === 'prev' ? '<' : '>'}
        </button>
      );
      const settings = {
        dots: false,
        infinite: false,
        centerMode: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 0,
        centerPadding: '0',
        nextArrow: <CustomArrow direction="next" />,
        prevArrow: <CustomArrow direction="prev" />,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };
  const expertiseItems = [
    
      // {
      //   title: "FRACTIONAL DISTILLATION",
      //   image: expertise4,
      //   description: "A technique used to isolate or purify various components present in essential oils, fractional distillation separates the volatile oil in different fractions or portions at various boiling points.",
      //   link: "/expertise/fractional-distillation"
      // },
      {
        title: "SUPERCRITICAL CO2 EXTRACTION",
        image: expertise3,
        description: "Supercritical fluid extraction is an efficient separation method of active ingredients from plant material. Supercritical solvent extraction is one of the gentlest, flexible, dynamic and nature-friendly techniques used for the extraction of spices, herbs and flowers using food grade CO2.",
        link: "/expertise/supercritical-co2-extraction"
      },{
      title: "STEAM DISTILLATION",
      image: expertise1,
      description: "Steam distillation is the technical process applied to recover the heat sensitive compounds from spices. Spice oils are unstable and heat sensitive compounds are present in the spice.",
      link: "/expertise/steam-distillation"
    }
    // ,
    // {
    //     title: "SOLVENT EXTRACTION",
    //     image: expertise2,
    //     description: "The method of solvent extraction uses a separation solvent, which is generally non-volatile has a high boiling point and is miscible with the mixture, but doesn’t form an isotropic mixture as a medium to extract essential active elements from spices.",
    //     link: "/expertise/solvent-extraction"
    //   }
    // Add other expertise items similarly
  ];

  return (
    <section className="page-content light">
      <div className="container" style={{ marginTop: '10px' }}>
        <div className="row">
          <div className="section-header text-center">
            <h3>Our Expertise</h3>
          </div>
          <div className="content-wrapper">
            <div className="thumb-slider  slick-initialized slick-slider slick-dotted" type="button">
            <Slider {...settings}>
              {expertiseItems.map((item, index) => (
                <div key={index} >
                  <Link to={item.link} className="slider-card">
                    <div className="slider-card-image">
                      <img alt="Our Expertise" src={item.image} />
                    </div>
                    <div className="slider-card-description">
                      <h5>{item.title}</h5>
                      <p className="text-justify">{item.description}</p>
                      <span className="readmore_span">Read More &gt;</span>
                    </div>
                  </Link>
                </div>
              ))}
                </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;